// @ts-nocheck
import type { Requests } from '../../../../base/realtime-session';
import type { AnalyticsSubscriptions } from '../../../../types/server/modules/analytics/subscriptions';

export type * from '../../../../types/server/modules/analytics/subscriptions';

export const createSubscriptions = ( requests: Requests ): AnalyticsSubscriptions => ({
  UiWidgetLayoutsReadmodel: ( params, onChange ) => {
          return requests.subscribe( `/ui-widget-layouts-readmodel/:id?`, params, 'UiWidgetLayoutsReadmodel', onChange );
          }
});
